// Copyright (c) 2026 Chain Capital Technologies Ltd. All rights reserved.
// See LICENSE file in the project root for full license information.

export function NotFound() {
  return (
    <div class="lookup-not-found">
      <h1 class="lookup-not-found-title">Page not found</h1>
      <p>That URL doesn't go anywhere on the verifier surface.</p>
      <a class="btn btn-link lookup-back-link" href="/">
        ← Back to lookup
      </a>
    </div>
  );
}
